import { Link } from 'gatsby';
import React from 'react';
import { useCmsCampaign } from '../../../../../cms/hooks/useCmsCampaign';
import { MobileDropdown } from '../../../../../components/dropdown/MobileDropdown';
import { MenuIcon } from '../../../../../components/icons/MenuIcon';
import Layout from '../../../../../components/layout';
import Seo from '../../../../../components/seo';
import { config } from '../../data/config';

import "./layout.scss";

const GoldenEyeCareLayout = ({ activePage, children, skipEndDate = true, isEndedPage = false }) => {
    const [open, setOpen] = React.useState(false);

    const { layoutConfig, seoConfig } = useCmsCampaign('goldeneyecare');
    React.useEffect(() => {
        if (!isEndedPage) {
            window.location.href = '/campaigns/goldeneyecare/ended';
        }
    }, []);

    return (
        <Layout {...layoutConfig} skipEndDate={skipEndDate}>
            <Seo {...seoConfig}></Seo>
            <div className="campaign_goldeneyecare">
                <div className="header">
                    <div className="flex padding space-between">
                        <Link to={config.nav.data.find(x => x.id === 'home').href}>
                            <div className="logo flex padding">
                                <img src={config.images.eventLogo} />
                            </div>
                        </Link>
                        <div className="desktop-nav flex center padding">
                            {
                                config.nav.data.filter(x => !x.hiddenInNav).map(x => (
                                    <div key={x.id} className="nav-item" id={x.id}>
                                        <a className={activePage === x.id ? 'active' : ''} href={x.href}>{x.name}</a>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='mobile-nav flex center padding'>
                            <div style={{ cursor: 'pointer', maxHeight: '28px' }} onClick={() => setOpen(!open)}>
                                <MenuIcon height={28} />
                            </div>
                        </div>
                    </div>
                    <MobileDropdown open={open} options={config.nav.data} activePage={activePage} />
                </div>
                <div className="body">
                    {children}
                </div>
                <div className="footer">
                    {/* <div className="flex center padding">
                        主辧單位：<img src={config.images.finddocLogo}></img>
                    </div> */}
                    <div className="flex center padding">
                        {/* 合作伙伴： 
                        <img style={{ width: '60px', paddingRight: '20px' }} src={config.images.gafLogo} />  */}
                        支持機構： <img style={{ width: '60px', paddingRight: '20px' }} src={config.images.bayerLogo} />
                    </div>
                    <div className="flex center padding" style={{ textAlign: 'center' }}>
                        本網頁謹供學術或參考用途，並非提供任何醫療意見或建議任何商品或服務，亦不可取代任何診斷或治療。
                        有關您個人的治療情況，請諮詢您的醫生為您作出準確的診斷，並提供適合的治療。
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default GoldenEyeCareLayout;
